var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerScrolled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.860617 0.171967C-0.223273 0.171967 -0.223273 1.83817 0.860617 1.83817H14.1746C15.2596 1.83817 15.2596 0.171967 14.1746 0.171967H0.860617ZM14.1972 6.83887H0.859593C-0.267325 6.79372 -0.267325 8.57121 0.859593 8.50507H14.1736C15.28 8.54916 15.3016 6.83887 14.1962 6.83887H14.1972ZM0.859593 13.5058C-0.224297 13.5058 -0.224297 15.172 0.859593 15.172H14.1736C15.2585 15.172 15.2585 13.5058 14.1736 13.5058H0.859593Z",
    fill: "#264653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerScrolled);
export default __webpack_public_path__ + "static/media/hamburgerScrolled.57d595563123aedcc0883cc95bc3226b.svg";
export { ForwardRef as ReactComponent };